import * as Enumerable from 'linq-es2015'


export default {
    props: {
        index: Number,
        modelId: Object,
        modelObject: Object,
        actionLabel: String,
        actionTitle: String,
        editMode: Boolean,
        parentScreenParameters: Object
    },

    data: function () {
        return {
            loading: false,
            model: this.emptyModel(),
            modelErrors: null,
            modelMetadata: {
                
            },
            dataSourceLookupTechShipCarriers: [],
            dataSourceLookupTechShipSubscriptions: [],
            dataSourceLookupTechShipWarehousePlugins: [],
            dataSourceLookupTimeZones: [],

        }
    },

    computed: {
        screenTitle: function () {
            return 'techSHIP Portal';
        },

        
    },

    methods: {
        fieldHasError: function (field) {
            return this.modelErrors != null && this.modelErrors.hasOwnProperty(field);
        },

        fieldErrorMessage: function (field) {
            if (this.modelErrors == null) {
                return '';
            }

            if (this.modelErrors.hasOwnProperty(field) === false) {
                return '';
            }
            
            return this.modelErrors[field];
        },

        

        emptyModel() {
            return {
                ApplicationId: 0,
                PortalName: null,
                DomainName: null,
                DomainSuffix: null,
                WarehousePlugin: null,
                ChargeBeeSubscriptionId: null,
                Timezone: null,
                AdminUser: null,
                Carriers: [],

            }
        },

        async onSaveModelDataSource() {
            try {
                this.loading = true;

                let url = this.$prepareServerUrl('/api/ui/techship_portals', this.modelId, this.modelObject, this.$route.params);
                let response = await this.$http.post(url, this.model, {  });

                this.$processServerJsonResponse(response.body, this.refreshScreen);

                this.model = response.body;
                return true;
            }
            catch (ex) {
                this.modelErrors = null;

                if (ex.body.errors) {
                    this.modelErrors = ex.body.errors;
                    return false;
                } else {
                    this.$processException(ex);    
                }

                return false;
            }
            finally {
                this.loading = false;
            }
        },

        async onLookupTechShipCarriersLookupDataSource(parentValue) {
            
            let url = '/api/ui/techship_portals/lookup_techship_carriers';
            url = this.$prepareServerUrl(url, this.modelId, this.modelObject);
            let response = await this.$http.get(url);
            this.dataSourceLookupTechShipCarriers = response.body;
        },

        async onLookupTechShipSubscriptionsLookupDataSource(parentValue) {
            
            let url = '/api/ui/techship_portals/lookup_techship_subscriptions/'+ this.model.ApplicationId;
            url = this.$prepareServerUrl(url, this.modelId, this.modelObject);
            let response = await this.$http.get(url);
            this.dataSourceLookupTechShipSubscriptions = response.body;
        },

        async onLookupTechShipWarehousePluginsLookupDataSource(parentValue) {
            
            let url = '/api/ui/techship_portals/lookup_techship_warehouse_plugins';
            url = this.$prepareServerUrl(url, this.modelId, this.modelObject);
            let response = await this.$http.get(url);
            this.dataSourceLookupTechShipWarehousePlugins = response.body;
        },

        async onLookupTimeZonesLookupDataSource(parentValue) {
            
            let url = '/api/ui/techship_portals/lookup_timezones';
            url = this.$prepareServerUrl(url, this.modelId, this.modelObject);
            let response = await this.$http.get(url);
            this.dataSourceLookupTimeZones = response.body;
        },

        onCarriersChange(model, value) {
            // Refresh model fields from selected item.
            let valueItem = value.Item;

            if (!valueItem) {
                let dsItem = Enumerable.AsEnumerable(this.dataSourceLookupTechShipCarriers).FirstOrDefault(e => e.Key == value);

                if (dsItem) {
                    valueItem = dsItem.Item;
                }
            }

            if (valueItem) {
                for (var propertyName in valueItem) {
                    if (model.hasOwnProperty(propertyName)) {
                        model[propertyName] = valueItem[propertyName];
                    }
                }
            }

            // Refresh cascade lookups.
            

            // Custom OnChange action.
            
        },

        onChargeBeeSubscriptionIdChange(model, value) {
            // Refresh model fields from selected item.
            let valueItem = value.Item;

            if (!valueItem) {
                let dsItem = Enumerable.AsEnumerable(this.dataSourceLookupTechShipSubscriptions).FirstOrDefault(e => e.Key == value);

                if (dsItem) {
                    valueItem = dsItem.Item;
                }
            }

            if (valueItem) {
                for (var propertyName in valueItem) {
                    if (model.hasOwnProperty(propertyName)) {
                        model[propertyName] = valueItem[propertyName];
                    }
                }
            }

            // Refresh cascade lookups.
            

            // Custom OnChange action.
            
        },

        onTimezoneChange(model, value) {
            // Refresh model fields from selected item.
            let valueItem = value.Item;

            if (!valueItem) {
                let dsItem = Enumerable.AsEnumerable(this.dataSourceLookupTimeZones).FirstOrDefault(e => e.Key == value);

                if (dsItem) {
                    valueItem = dsItem.Item;
                }
            }

            if (valueItem) {
                for (var propertyName in valueItem) {
                    if (model.hasOwnProperty(propertyName)) {
                        model[propertyName] = valueItem[propertyName];
                    }
                }
            }

            // Refresh cascade lookups.
            

            // Custom OnChange action.
            
        },

        onWarehousePluginChange(model, value) {
            // Refresh model fields from selected item.
            let valueItem = value.Item;

            if (!valueItem) {
                let dsItem = Enumerable.AsEnumerable(this.dataSourceLookupTechShipWarehousePlugins).FirstOrDefault(e => e.Key == value);

                if (dsItem) {
                    valueItem = dsItem.Item;
                }
            }

            if (valueItem) {
                for (var propertyName in valueItem) {
                    if (model.hasOwnProperty(propertyName)) {
                        model[propertyName] = valueItem[propertyName];
                    }
                }
            }

            // Refresh cascade lookups.
            

            // Custom OnChange action.
            
        },

        onLoadFieldDataSources() {
            this.onLookupTechShipCarriersLookupDataSource();
            this.onLookupTechShipSubscriptionsLookupDataSource();
            this.onLookupTechShipWarehousePluginsLookupDataSource();
            this.onLookupTimeZonesLookupDataSource();

        },

        show() {
            if (this.modelObject && this.modelObject.Id > 0)
            {
                // Edit
                this.model = this.modelObject;
            } else {
                // Create
                this.model = this.emptyModel();
                this.$applyModelFields(this.modelObject, this.model);
            }

            this.onLoadFieldDataSources();
            this.$refs.dialog.show();
        },

        hide() {
            this.$refs.dialog.hide();
        },

        onDialogHide() {
            this.$emit('hide');
        },

        async onOkClick() {
            let validateResult = await this.$refs.modelForm.validate();
            if (validateResult) {
                let saveResult = await this.onSaveModelDataSource();
                if (saveResult) {
                    this.$emit('ok', { index: this.index, model: this.model, files: null });
                    this.hide();
                }
            }
        },

        onCancelClick() {
            this.hide();
        }
    }
}